<template>
  <div class="alert_dialog">
    <div class="alert_dialog_top">提示</div>
    <div class="alert_dialog_content">
      <p>
        {{showMsg}}
      </p>
      <!--账号注册成功。平台方将尽快为您进行账户审核，审核结果会以短信形式进行通知，请您保持手机畅通！-->
      <!--密码修改成功，请采用新的密码进行账户登录！-->
    </div>
    <div class="alert_dialog_btn">
      <button class="btn_normal" @click="confirmBtn()">确定</button>
    </div>
  </div>
</template>

<script type="es6">
    export default {
        name: 'alert-dialog',
      props: ['showMsg'],
      data() {
          return {

          }
      },
      methods: {
          confirmBtn() {
            this.$emit('confirm', {showType: 'login'});
          }
      }
    }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/base-color";
.alert_dialog {
  width: 548px;
  margin-bottom: 60px;

  .alert_dialog_top {
    width: calc(100% - 30px);
    height: 40px;
    line-height: 40px;
    background-color: rgba(247, 247, 248, 1);
    border-bottom: 1px solid #eeeeee;
    padding-left: 30px;
  }

  .alert_dialog_content {
    background-color: #ffffff;

    p {
      padding: 40px 75px;
    }
  }

  .alert_dialog_btn {
    background-color: #ffffff;
    padding: 30px 0;
    text-align: right;

    button {
      margin-right: 55px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public-component/alert-dialog.vue